const ENV = {
  API_PATH: 'https://rodms.stage.aquabox.link/api',
}

export { ENV }
